// @flow
import React from "react"
import { Route, IndexRoute } from "react-router"

import * as Routes from "./RoutesSync"
import Root from "mmb/scenes/Root"
import RouteWrapper from "mmb/components/RouteWrapper/RouteWrapper"
import NotFound from "common/components/NotFound/NotFound"
import { BOOKING_LINKS } from "common/consts/deeplink"

export default function getRouter(lang: string) {
  const prefix = `/${lang}`

  return (
    <Route>
      <Route component={Root} path="/">
        <Route name="manage" path={`${prefix}/manage(/:bookingId)`} component={RouteWrapper}>
          <IndexRoute component={Routes.AccountBooking} />
          {Object.values(BOOKING_LINKS).map(service => (
            // $FlowFixMe
            <Route key={service} path={service} component={Routes.AccountBooking} />
          ))}
        </Route>
        <Route name="account" path={`${prefix}/account`} component={RouteWrapper}>
          <IndexRoute component={Routes.Account} />
          <Route path="bookings/:bookingId">
            <IndexRoute component={Routes.AccountBooking} />
            {Object.values(BOOKING_LINKS).map(service => (
              // $FlowFixMe
              <Route key={service} path={service} component={Routes.AccountBooking} />
            ))}
          </Route>
          <Route name="starred" path="starred" component={Routes.Starred} />
        </Route>
      </Route>

      <Route status={404} path={`${prefix}*`} component={NotFound} />
    </Route>
  )
}
